/* eslint-disable @typescript-eslint/explicit-function-return-type */
import axios from "axios";

const token = (): string =>
  localStorage.getItem("tokens") ?? sessionStorage.getItem("tokens") ?? "";

export const getAccessToken = (): string => {
  try {
    return JSON.parse(token()).access_token;
  } catch (e) {
    return "";
  }
};

const UNAUTHORIZED_ERROR_CODE = 401;

const URL = process.env.REACT_APP_BASE_API_URL ?? "";
const version = process.env.REACT_APP_BASE_API_VERSION ?? "";

const baseURL = `${URL}/${version}`;

export const WorkorderDownloadAPICall = axios.create({
  baseURL,
  headers: {
    Authorization: `Bearer ${getAccessToken()}`,
    API_CONSUMER: "TRIALING",
  },
  responseType: "blob",
});

WorkorderDownloadAPICall.interceptors.request.use(
  function (config) {
    config.headers.Authorization = `Bearer ${getAccessToken()}`;
    return config;
  },
  async function (error) {
    return await Promise.reject(new Error(error));
  }
);

export const PlatFormAPIAxiosInstance = axios.create({
  baseURL,
  headers: {
    "Cache-Control": "no-cache",
    Authorization: `Bearer ${getAccessToken()}`,
  },
});

PlatFormAPIAxiosInstance.interceptors.request.use(
  function (config) {
    config.headers.Authorization = `Bearer ${getAccessToken()}`;
    return config;
  },
  async function (error) {
    return await Promise.reject(new Error(error));
  }
);
// NOTE: Field geometries are intentionally passed through untouched. MultiPolygon
// fields used to be collapsed to their largest sub-polygon here; that conversion
// has been removed so the map/plot flow can render and use every sub-polygon.
PlatFormAPIAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === UNAUTHORIZED_ERROR_CODE) {
      //   authService.getAccessToken();
      // void logout();
    }
  }
);

export default PlatFormAPIAxiosInstance;
